module.exports = __webpack_public_path__ + "315dc23febd8a15a380522de94cc8c82.MP3";